export const commonDataGridSx = (isMobile) => ({
    border: 0, 
    // Cells
    '& .MuiDataGrid-cell': { fontSize: { xs: '12px', sm: '13px' }, whiteSpace: 'nowrap', py: isMobile ? 1.5 : 0.5, }, 

    // Header text
    '& .MuiDataGrid-columnHeaderTitle': { fontSize: { xs: '13px', sm: '15px' },fontWeight: '600', whiteSpace: 'normal',lineHeight: '1.3', textAlign: 'center',},

    // Header / row heights
    '& .MuiDataGrid-columnHeaders':  { minHeight: isMobile ? 55 : 45, },

    '& .MuiDataGrid-row': { minHeight: isMobile ? 72 : 45, },

    // Icon buttons
    '& .MuiIconButton-root': { padding: { xs: 0.5, sm: 1 },},
    
    // Footer responsive
    '& .MuiDataGrid-footerContainer': { flexDirection: { xs: 'column', sm: 'row' }, gap: 1, },
    
    // Remove focus outline
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {outline: "none"},
    
    // Prevent horizontal overflow on mobile
    "& .MuiDataGrid-main": {overflowX: "auto",},
    
    // Page size selector / pagination spacing
    "& .MuiTablePagination-root": {width: "100%", justifyContent: { xs: "space-between", sm: "flex-end" },},
    
    // Make quick filter input full width on mobile
    "& .MuiDataGrid-toolbarQuickFilter": { width: { xs: "100%", sm: 250 },},

    '& .MuiDataGrid-checkboxInput': { width: 20, height: 20 },
            
});
